import styled from "@emotion/styled";
import { RadioGroup } from "@mui/material";

export const StyledRadioButtonsWrapper = styled(
    RadioGroup,
    {
        shouldForwardProp: (propName) => propName !== "addMargin",
    }
)<{ addMargin: boolean }>(({ theme, addMargin }) => ({
    display: "flex",
    flexDirection: "row",
    marginTop: theme.spacing(1),
    gap: theme.spacing(1),
    marginBottom: theme.spacing(addMargin ? 2 : 0),
}));
